import {toTitleCase} from './toTitleCase';

// Structural rather than AfriexAdminUser: AfriexOTCTrade carries its own
// `submittedBy`/`approvedBy` shape whose `role` is a plain string, and
// AfriexRatePromo's `meta.admin` is a Partial, so both fields are optional.
type NamedRoleHolder = {name?: string; role?: string};

// Throws on a missing item or role rather than rendering a placeholder, so
// every call site guards its optional field first (see OTCTradeSummary,
// TierSummary, EventTierSummary, SignupBonusSummary, Summary). Explicit
// guards keep that contract visible instead of hiding it behind `any`.
export const formatName = (item: NamedRoleHolder | undefined) => {
  if (!item) {
    throw new TypeError('formatName requires an item');
  }
  if (!item.role) {
    throw new TypeError('formatName requires an item with a role');
  }
  return `${item.name}(${toTitleCase(item.role.replace(/[-_.]/g, ' '))})`;
};
